
export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-black border-t border-white/10">
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          <div className="lg:col-span-2">
            <img src="/logo.png" alt="Lakes Area Sealcoating" className="w-56 mb-6" />
            <p className="text-gray-400 mb-6 leading-relaxed">
              Professional driveway sealcoating and crack repair serving Lakes Area and Walworth County, Wisconsin.
              Protecting your asphalt investment with premium materials and expert craftsmanship.
            </p>
            <div className="space-y-4">
              <div className="flex items-center gap-4">
                <div className="w-10 h-10 bg-orange-500 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-phone-fill text-white text-sm"></i>
                </div>
                <div>
                  <p className="text-gray-500 text-xs uppercase tracking-widest">Call or Text</p>
                  <a href="tel:262-215-0688" className="text-white font-bold text-lg hover:text-orange-400 transition-colors">(262) 215-0688</a>
                </div>
              </div>
              <div className="flex items-center gap-4">
                <div className="w-10 h-10 bg-orange-500 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-mail-fill text-white text-sm"></i>
                </div>
                <div>
                  <p className="text-gray-500 text-xs uppercase tracking-widest">Email</p>
                  <a href="mailto:info@lakesareaseal.com" className="text-white font-bold hover:text-orange-400 transition-colors">info@lakesareaseal.com</a>
                </div>
              </div>
              <div className="flex items-center gap-4">
                <div className="w-10 h-10 bg-orange-500 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-map-pin-fill text-white text-sm"></i>
                </div>
                <div>
                  <p className="text-gray-500 text-xs uppercase tracking-widest">Serving</p>
                  <p className="text-white font-bold">Walworth County, WI</p>
                </div>
              </div>
            </div>
          </div>

          <div>
            <h4 className="font-display text-xl font-bold text-white uppercase mb-6 tracking-wide">Our Services</h4>
            <ul className="space-y-3">
              {['Driveway Sealcoating', 'Crack Filling & Repair', 'Full Maintenance Package', 'Free Estimates'].map((service) => (
                <li key={service}>
                  <a href="#contact" className="text-gray-400 hover:text-orange-400 transition-colors text-sm">{service}</a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-display text-xl font-bold text-white uppercase mb-6 tracking-wide">Service Areas</h4>
            <ul className="space-y-3">
              {['Elkhorn, WI', 'Lake Geneva', 'Williams Bay', 'Fontana-on-Geneva Lake', 'Delavan', 'Sharon', 'Walworth', 'East Troy'].map((area) => (
                <li key={area} className="flex items-center gap-2 text-gray-400 text-sm">
                  <i className="ri-map-pin-2-line text-orange-500 text-xs"></i>{area}
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 mt-12 pt-12 text-center">
          <h4 className="font-display text-4xl font-bold text-white uppercase mb-4">Ready to Protect Your Driveway?</h4>
          <p className="text-gray-400 mb-8 max-w-2xl mx-auto">Get your free estimate today and see why Lakes Area homeowners trust us with their driveway maintenance.</p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a href="tel:262-215-0688" className="bg-orange-500 hover:bg-orange-600 text-white px-8 py-4 rounded-lg text-lg font-bold transition-all duration-200 inline-flex items-center justify-center gap-2">
              <i className="ri-phone-fill"></i> Call (262) 215-0688
            </a>
            <a href="#contact" className="border-2 border-white/20 text-white px-8 py-4 rounded-lg text-lg font-bold hover:bg-white hover:text-black transition-all duration-200 inline-flex items-center justify-center gap-2">
              <i className="ri-calculator-line"></i> Get Free Quote
            </a>
          </div>
        </div>
      </div>

      <div className="border-t border-white/10 bg-black/80">
        <div className="max-w-7xl mx-auto px-6 py-5 flex flex-col md:flex-row justify-between items-center gap-4">
          <div className="text-gray-500 text-sm">© {currentYear} Lakes Area Sealcoating · <a href="https://lakesareaseal.com" className="hover:text-orange-400 transition-colors">lakesareaseal.com</a></div>
          <div className="flex items-center gap-5">
            <a href="https://www.facebook.com/profile.php?id=61563922962661" target="_blank" rel="noopener noreferrer"
              className="w-9 h-9 bg-white/5 border border-white/10 rounded-lg flex items-center justify-center hover:bg-orange-500 hover:border-orange-500 transition-all duration-200" aria-label="Facebook">
              <i className="ri-facebook-fill text-white text-sm"></i>
            </a>
            <span className="text-gray-500 text-sm">Licensed & Insured · Walworth County, WI</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
